export class BrowserUtils {
  static goTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}
